import React from 'react';
export function Methodology() {
  return <section id="domaines-interventions" className="py-24 bg-riskeys-gray-light relative" data-id="element-268">
      {/* Background pattern */}
      <div className="absolute inset-0 z-0 opacity-50" data-id="element-269">
        <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" data-id="element-270">
          <pattern id="diagonalLines" patternUnits="userSpaceOnUse" width="40" height="40" patternTransform="rotate(45)" data-id="element-271">
            <line x1="0" y1="0" x2="0" y2="40" stroke="#E4E9F2" strokeWidth="1" data-id="element-272" />
          </pattern>
          <rect width="100%" height="100%" fill="url(#diagonalLines)" data-id="element-273" />
        </svg>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-274">
        <div className="text-center mb-20" data-id="element-275">
          <h2 className="text-3xl md:text-4xl font-bold text-riskeys-dark mb-5 leading-tight" data-id="element-276">
            Nos domaines{' '}
            <span className="text-riskeys-blue-default" data-id="element-277">d'interventions</span>
          </h2>
          <div className="w-20 h-1 bg-riskeys-accent-default mx-auto mb-6" data-id="element-278"></div>
          <p className="max-w-3xl mx-auto text-lg text-gray-600 leading-relaxed" data-id="element-279">
            Nos expertises couvrent un large spectre de vos besoins en assurance
          </p>
        </div>
        <div className="bg-white rounded-2xl shadow-premium p-8 border border-gray-100 mb-20" data-id="element-280">
          <div className="flex flex-col md:flex-row md:items-center gap-10" data-id="element-281">
            <div className="md:w-1/2" data-id="element-282">
              <h3 className="text-2xl font-bold text-riskeys-dark mb-6" data-id="element-283">
                L'assurance comme levier de performance
              </h3>
              <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-284">
                Chez Riskeys, nous considérons l'assurance non pas comme une
                simple dépense, mais comme un véritable levier de performance
                pour votre entreprise. Notre approche de conseil et d'audit vise
                à optimiser vos contrats pour qu'ils correspondent parfaitement
                à vos besoins réels.
              </p>
              <div className="flex flex-col gap-4" data-id="element-285">
                <div className="flex items-start" data-id="element-286">
                  <div className="flex-shrink-0 h-6 w-6 rounded-full bg-riskeys-blue-light/20 flex items-center justify-center mt-1" data-id="element-287">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5 text-riskeys-blue-default" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-288">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-289" />
                    </svg>
                  </div>
                  <p className="ml-3 text-gray-600" data-id="element-290">
                    <span className="font-semibold text-riskeys-dark" data-id="element-291">
                      Indépendance totale
                    </span>{' '}
                    - Aucun lien avec les compagnies d'assurance
                  </p>
                </div>
                <div className="flex items-start" data-id="element-292">
                  <div className="flex-shrink-0 h-6 w-6 rounded-full bg-riskeys-blue-light/20 flex items-center justify-center mt-1" data-id="element-293">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5 text-riskeys-blue-default" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-294">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-295" />
                    </svg>
                  </div>
                  <p className="ml-3 text-gray-600" data-id="element-296">
                    <span className="font-semibold text-riskeys-dark" data-id="element-297">
                      Approche sur-mesure
                    </span>{' '}
                    - Adaptée à votre secteur et à votre profil de risque
                  </p>
                </div>
                <div className="flex items-start" data-id="element-298">
                  <div className="flex-shrink-0 h-6 w-6 rounded-full bg-riskeys-blue-light/20 flex items-center justify-center mt-1" data-id="element-299">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5 text-riskeys-blue-default" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-300">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-301" />
                    </svg>
                  </div>
                  <p className="ml-3 text-gray-600" data-id="element-302">
                    <span className="font-semibold text-riskeys-dark" data-id="element-303">
                      Paiement au résultat
                    </span>{' '}
                    - Pas d'économies = pas d'honoraires
                  </p>
                </div>
              </div>
            </div>
            <div className="md:w-1/2" data-id="element-304">
              <img src="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80" alt="Analyse de contrats d'assurance" className="w-full h-auto rounded-xl shadow-md object-cover" data-id="element-305" />
            </div>
          </div>
        </div>
        {/* Domaines d'intervention */}
        <div className="grid md:grid-cols-3 gap-8 mb-20" data-id="element-306">
          <div className="bg-white rounded-2xl shadow-soft p-8 border-l-4 border-riskeys-blue-default hover:shadow-premium transition-all duration-300" data-id="element-307">
            <div className="w-16 h-16 bg-riskeys-blue-light/20 rounded-2xl flex items-center justify-center mb-6" data-id="element-308">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-riskeys-blue-default" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-309">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" data-id="element-310" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-riskeys-dark mb-4" data-id="element-311">
              Optimisation Assurance
            </h3>
            <p className="text-gray-600 mb-6" data-id="element-312">
              Audit et optimisation de vos contrats existants pour réduire vos
              coûts tout en améliorant vos garanties. Notre approche
              indépendante nous permet d'identifier les meilleures solutions
              pour votre entreprise.
            </p>
            <a href="#contact" className="text-riskeys-blue-default font-semibold flex items-center hover:text-riskeys-blue-dark transition-colors" data-id="element-313">
              <span className="mr-2" data-id="element-314">En savoir plus</span>
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-315">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" data-id="element-316" />
              </svg>
            </a>
          </div>
          <div className="bg-white rounded-2xl shadow-soft p-8 border-l-4 border-riskeys-accent-default hover:shadow-premium transition-all duration-300" data-id="element-317">
            <div className="w-16 h-16 bg-riskeys-accent-light rounded-2xl flex items-center justify-center mb-6" data-id="element-318">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-319">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" data-id="element-320" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-riskeys-dark mb-4" data-id="element-321">
              Assurances IARD
            </h3>
            <p className="text-gray-600 mb-6" data-id="element-322">
              Expertise en assurances Incendie, Accidents et Risques Divers.
              Nous analysons et optimisons vos contrats multirisques
              professionnels, RC, flottes automobiles et autres risques
              d'entreprise.
            </p>
            <a href="#contact" className="text-riskeys-blue-default font-semibold flex items-center hover:text-riskeys-blue-dark transition-colors" data-id="element-323">
              <span className="mr-2" data-id="element-324">En savoir plus</span>
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-325">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" data-id="element-326" />
              </svg>
            </a>
          </div>
          <div className="bg-white rounded-2xl shadow-soft p-8 border-l-4 border-riskeys-dark hover:shadow-premium transition-all duration-300" data-id="element-327">
            <div className="w-16 h-16 bg-riskeys-gray-default rounded-2xl flex items-center justify-center mb-6" data-id="element-328">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-riskeys-dark" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-329">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" data-id="element-330" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-riskeys-dark mb-4" data-id="element-331">
              Assurances de Personnes
            </h3>
            <p className="text-gray-600 mb-6" data-id="element-332">
              Conseil et optimisation de vos contrats santé, prévoyance et
              retraite collective. Nous vous aidons à offrir les meilleures
              protections à vos collaborateurs tout en maîtrisant vos coûts.
            </p>
            <a href="#contact" className="text-riskeys-blue-default font-semibold flex items-center hover:text-riskeys-blue-dark transition-colors" data-id="element-333">
              <span className="mr-2" data-id="element-334">En savoir plus</span>
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-335">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" data-id="element-336" />
              </svg>
            </a>
          </div>
        </div>
        <div className="mt-24" data-id="element-337">
          <div className="bg-white rounded-2xl shadow-premium p-10 border border-gray-100 text-center" data-id="element-338">
            <h4 className="text-xl font-bold text-riskeys-dark mb-6" data-id="element-339">
              Notre approche d'intervention
            </h4>
            <div className="grid md:grid-cols-4 gap-6 mb-10" data-id="element-340">
              <div className="p-5 bg-riskeys-gray-light rounded-xl" data-id="element-341">
                <div className="w-12 h-12 rounded-full bg-riskeys-accent-default text-white flex items-center justify-center mx-auto mb-4 text-xl font-bold" data-id="element-342">
                  1
                </div>
                <h5 className="font-semibold text-riskeys-blue-default mb-2" data-id="element-343">
                  Audit initial
                </h5>
                <p className="text-sm text-gray-600" data-id="element-344">
                  Analyse technique et financière des contrats existants pour
                  identifier les optimisations possibles.
                </p>
              </div>
              <div className="p-5 bg-riskeys-gray-light rounded-xl" data-id="element-345">
                <div className="w-12 h-12 rounded-full bg-riskeys-accent-default text-white flex items-center justify-center mx-auto mb-4 text-xl font-bold" data-id="element-346">
                  2
                </div>
                <h5 className="font-semibold text-riskeys-blue-default mb-2" data-id="element-347">
                  Recommandations
                </h5>
                <p className="text-sm text-gray-600" data-id="element-348">
                  Présentation des solutions d'optimisation et des économies
                  potentielles identifiées.
                </p>
              </div>
              <div className="p-5 bg-riskeys-gray-light rounded-xl" data-id="element-349">
                <div className="w-12 h-12 rounded-full bg-riskeys-accent-default text-white flex items-center justify-center mx-auto mb-4 text-xl font-bold" data-id="element-350">
                  3
                </div>
                <h5 className="font-semibold text-riskeys-blue-default mb-2" data-id="element-351">
                  Négociation
                </h5>
                <p className="text-sm text-gray-600" data-id="element-352">
                  Mise en œuvre des optimisations et négociation avec les
                  assureurs en votre nom.
                </p>
              </div>
              <div className="p-5 bg-riskeys-gray-light rounded-xl" data-id="element-353">
                <div className="w-12 h-12 rounded-full bg-riskeys-accent-default text-white flex items-center justify-center mx-auto mb-4 text-xl font-bold" data-id="element-354">
                  4
                </div>
                <h5 className="font-semibold text-riskeys-blue-default mb-2" data-id="element-355">
                  Suivi continu
                </h5>
                <p className="text-sm text-gray-600" data-id="element-356">
                  Accompagnement permanent et adaptation des solutions à
                  l'évolution de vos besoins.
                </p>
              </div>
            </div>
            <p className="text-xl text-riskeys-dark font-medium mb-8 leading-relaxed" data-id="element-357">
              Notre rémunération est uniquement basée sur un pourcentage des
              économies réalisées.
              <br data-id="element-358" />
              <span className="font-semibold text-riskeys-blue-default" data-id="element-359">
                Pas d'économies = pas d'honoraires.
              </span>
            </p>
            <a href="#contact" className="inline-block bg-riskeys-accent-default text-white font-semibold py-3.5 px-8 rounded-full hover:bg-riskeys-accent-dark transition-all duration-300 shadow-md hover:shadow-lg transform hover:-translate-y-0.5" data-id="element-360">
              Demander un audit gratuit
            </a>
          </div>
        </div>
      </div>
    </section>;
}